<template>
  <v-form
    :disabled="form.processing"
    @submit.prevent="submit"
  >
    <v-card>
      <v-card-title>{{ $t('Team name') }}</v-card-title>
      <v-card-subtitle>{{ $t("The team's name and owner information") }}</v-card-subtitle>
      <v-card-text>
        <v-text-field
          v-model="form.name"
          solo
          :placeholder="$t('Enter team name')"
          :disabled="! permissions.canUpdateTeam"
          :loading="form.processing"
          :error-messages="form.errors.name"
          style="max-width: 400px;"
        />

        <div class="mb-4">
          <p class="mb-1 text-subtitle-2 grey--text text--darken-3 font-weight-bold">
            {{ $t('Team type') }}
          </p>
          <p class="mb-0 text-body-2 d-flex align-center">
            {{ $page.props.user.current_team.plan }}
            <upgrade-team-button
              x-small
              class="ml-2"
            />
          </p>
        </div>

        <div>
          <p class="mb-1 text-subtitle-2 grey--text text--darken-3 font-weight-bold">
            {{ $t('Team owner') }}
          </p>
          <p
            v-if="team.owner.name"
            class="mb-0 text-body-2 font-weight-medium"
          >
            {{ team.owner.name }}
          </p>
          <p class="mb-0 text-body-2">
            {{ team.owner.email }}
          </p>
        </div>
      </v-card-text>
      <v-card-actions v-if="permissions.canUpdateTeam">
        <v-spacer />
        <v-btn
          type="submit"
          color="primary"
          :loading="form.processing"
          :disabled="form.processing"
        >
          {{ $t('Save changes') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</template>

<script>
export default {
  props: {
    team: {
      type: Object,
      required: true
    },
    permissions: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      form: this.$inertia.form({
        name: this.team.name
      })
    }
  },

  methods: {
    submit() {
      const url = this.route('team.update', this.team.id);
      this.form.patch(url);
    }
  }
}
</script>